var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { animated, to } from '@react-spring/web';
import { SvgImage } from './svg-image';
import { useStaticColors } from '../hooks/use-theme-colors';
import { useSpringValues } from '../hooks/use-spring-values';
var cls = classNames('image-circle');
export var SvgImageCircleDefaultProps = {
  r: 100,
  cx: 0,
  cy: 0,
  strokeWidth: 0,
  animate: true,
  encode: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n   \n  "], ["\n    ", "\n   \n  "])), function (_a) {
    var colors = _a.colors,
      isActive = _a.isActive;
    return theme.STROKE_FILL_COLORS({
      colors: colors,
      isActive: isActive,
      selector: cls.child('circle')
    });
  })
});
var CircleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(animated.svg)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Circle: styled(animated.circle).attrs(cls.attr('circle'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), CircleStyles),
  // backing for stroke and fill (allows a fallback fill)
  CircleMask: styled(animated.circle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CircleStyles),
  Image: styled(animated(SvgImage))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SvgImageCircle = function (props) {
  var className = props.className,
    imageUrl = props.imageUrl,
    encode = props.encode,
    children = props.children,
    isActive = props.isActive,
    strokeWidth = props.strokeWidth,
    style = props.style;
  // for data viz, it's better if we use explicit SVG fills etc, as these are more portable for export.
  var colors = useStaticColors(__assign({
    fill: 'transparent',
    stroke: 'transparent'
  }, props.colors || {}), {
    isActive: isActive
  });
  var clipId = "clip-".concat(imageUrl, "-").concat(Math.random().toString(36).slice(2, 11));
  var values = useSpringValues(props);
  // setup interpolation functions
  // we cannot calculate values from spring values directly, as these change internally and must be fed to react-spring's `to` interpolation function. 
  var width = function (r) {
    return r * 2;
  };
  var height = function (r) {
    return r * 2;
  };
  var x = function (cx, r) {
    return cx - width(r) / 2;
  };
  var y = function (cy, r) {
    return cy - height(r) / 2;
  };
  var maskRadius = function (r) {
    return Math.max(r - strokeWidth / 2, 0);
  };
  return React.createElement(My.Container, {
    style: style,
    overflow: "visible",
    className: cls.name(className),
    colors: props.colors,
    isActive: isActive,
    onClick: props.onClick
  }, React.createElement("defs", null, React.createElement("clipPath", {
    id: clipId
  }, React.createElement(My.CircleMask, {
    cx: values.cx,
    cy: values.cy,
    r: to([values.r], maskRadius)
  }))), React.createElement(My.Circle, {
    width: to([values.r], width),
    height: to([values.r], height),
    cy: values.cy,
    cx: values.cx,
    r: values.r,
    fill: colors.fill,
    stroke: colors.stroke,
    strokeWidth: strokeWidth
  }), imageUrl && React.createElement(My.Image, {
    encode: encode,
    x: to([values.cx, values.r], x),
    y: to([values.cy, values.r], y),
    href: imageUrl,
    width: to([values.r], width),
    height: to([values.r], height),
    clipPath: "url(#".concat(clipId, ")")
  }), children);
};
SvgImageCircle.cls = cls;
SvgImageCircle.defaultProps = SvgImageCircleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;